import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
// import { messageHandlers, socket } from '../websockets';
import { initializePeerAndAttachHandlers, peerEventHandlers, resetPeerHandlers } from "../p2p";
import { useNavigate } from "react-router-dom";
import { useEffect } from 'react';
import { displayPopMessage, showLoadingIcon, hideLoadingIcon } from "../utils";

function Home() {

  let navigate = useNavigate();

  function goToLink(data) {
    navigate(
      data.link,
      {
        replace: true,
        state: {
          iCreatedChallenge: true,
        }
      }
    );
    hideLoadingIcon();
  }

  useEffect(() => {
    return () => { resetPeerHandlers() };
  }, []);


  function userClickedOn(variant) {
    showLoadingIcon();

    peerEventHandlers.open = (id) => {
      goToLink({ link: `${variant}/${id}` })
    };

    peerEventHandlers.error = (err) => {
      console.log(err.type);
      console.log(err.message);
      displayPopMessage(`Error: ${err.type}`);
      displayPopMessage(`Error: ${err.message}`);
      hideLoadingIcon();
    };

    initializePeerAndAttachHandlers();
  }

  return (
    <div className="Home">
      <Container fluid="md" className="d-flex justify-content-center align-items-center vh-100">
        <Row className="text-center gx-5 gy-5">
          <Col md className="p-5 me-md-5">
            <Button onClick={() => userClickedOn('simple')} variant="info" size="lg">Simple</Button>
          </Col>
          <Col md className="p-5 ms-md-5">
            <Button onClick={() => userClickedOn('ultimate')} variant="info" size="lg">Ultimate</Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Home;